import React from 'react';

export const GRID_CONFIG = {
 
    columnHidingEnabled: false,
    columnAutoWidth: true,
    rowAlternationEnabled: true,
    searchPanel: {
        visible: true,
        placeholder: "Search..."
    },
    
    columnChooser: {
        enabled: true,
        mode: "select"
    },
    filterRow: {
        visible: false,
        applyFilter: "auto"
    },
    headerFilter: {
        visible: false
    }
    

}